import type { AccountType, DetailedAccount } from '../../../core'

/**
 * Builds the selection state for the accounts a widget actually renders.
 *
 * Derives from the account list rather than from `accountFilterMap`: the map is
 * seeded from `visibleAccounts` (which drops closed/hidden accounts) while the
 * list renders `detailedAccounts` (which keeps them). Starting from the map
 * therefore under-counted the checkboxes on screen, and the total *grew* as soon
 * as a bulk toggle wrote one of the missing guids into the map. Accounts with no
 * map entry default to unselected, so `total` always equals the number of
 * rendered checkboxes and stays stable across clicks.
 */
export const buildSelectionFilter = (
  accountFilterMap: Map<string, boolean>,
  accounts: DetailedAccount[],
  allowedAccountTypes: AccountType[] | undefined,
): Map<string, boolean> =>
  new Map(
    accounts
      .filter(
        (account) => !allowedAccountTypes || allowedAccountTypes.includes(account.account_type),
      )
      .map((account) => [account.guid, !!accountFilterMap.get(account.guid)]),
  )

export const getSelectionCounts = (selectionFilter: Map<string, boolean>) => ({
  selected: Array.from(selectionFilter.values()).filter(Boolean).length,
  total: selectionFilter.size,
})
